import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Image } from "src/@types";
import { Ii18nInterpolationObject } from "src/@types/i18next";

interface Props {
  id?: string;
  subtitle?: Ii18nInterpolationObject;
  description?: Ii18nInterpolationObject;
  image?: Image;
  isList?: boolean;
}

export const ProcessStepInfo: FC<Props> = ({
  id,
  subtitle,
  description,
  image,
  isList,
}) => {
  const { t } = useTranslation();

  const isHtml = (string) => /<\/?[a-z][\s\S]*>/i.test(string);

  return (
    <div className="flex flex-col gap-5">
      {subtitle && (
        <h5 className="text-xl text-purple-base font-bold pt-20 -mt-20" id={id}>
          {t(subtitle.i18nKey)}
        </h5>
      )}

      {isHtml(t(description.i18nKey)) ? (
        isList ? (
          <ul
            className="list-disc pl-4"
            dangerouslySetInnerHTML={{
              __html: t(description.i18nKey),
            }}
          />
        ) : (
          <div
            className="text-justify"
            dangerouslySetInnerHTML={{
              __html: t(description.i18nKey),
            }}
          />
        )
      ) : (
        <p className="text-justify">{t(description.i18nKey)}</p>
      )}

      {image && (
        <div className="flex justify-center border bg-white-base rounded-20 w-full p-5">
          <img src={image.url} alt={image.title} className="max-h-143.5" />
        </div>
      )}
    </div>
  );
};
